import styled from 'styled-components'
import { colors, device } from 'Styled/variables'

export const Container = styled.div<{ threeReviewsWarning: boolean }>`
  display: flex;
  padding: 24px 100px;
  flex-direction: column;
  display: ${({ threeReviewsWarning }) =>
    threeReviewsWarning ? `none` : `block`};
  pointer-events: ${({ threeReviewsWarning }) =>
    threeReviewsWarning ? `none` : `all`};
  position: ${({ threeReviewsWarning }) =>
    threeReviewsWarning ? `absolute` : `static`};

  @media ${device.mobileMax} {
    padding: 0;
  }
`

export const SectionTitle = styled.h5`
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  color: ${colors.mainText};
`

export const TrackPreviewContainer = styled.div`
  margin-bottom: 19px;
  @media ${device.mobileMin} {
    margin-bottom: 17px;
  }
`

export const TrackPreview = styled.div`
  height: 88px;
  padding: 4px;
  box-shadow: 0px 0px 6px 0px #00000040;
  border-radius: 8px;
`

export const OpenSpotify = styled.span`
  display: block;
  margin: 17px 0 9px;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.mainText};
  text-align: center;
`

export const OpenSpotifyLink = styled.a`
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.green};
  border-bottom: 1px dashed ${colors.green};
  cursor: pointer;
  &:hover,
  &:visited {
    color: ${colors.green};
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 24px 0;
`

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  padding: 9.5px 40px;
  height: 40px;
  font-size: 14px;
  border-radius: 27px;
  color: ${colors.white};
  background-color: ${colors.green};
  border: 1px solid ${colors.green};
`
